module.exports = __webpack_public_path__ + "static/media/BM_Leads.c29f925d.svg";